import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../components/AdminHeader';
import axios from 'axios';

function UpdateProducts() {

    const navigate = useNavigate();

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const [allProducts, setAllProducts] = useState([])

    const [searchItem, setSearchItem] = useState('')

    const fetchProduct = async () => {
        try {
            const response = await fetch(`${apiBaseUrl}/getAllProductsForNoSize/BLACKBATON_2526`);
            const data = await response.json();
            if (data.length > 0) {

                const filtered = data.filter(item =>
                    item.itemname?.toLowerCase().includes(searchItem.toLowerCase())
                );
                setAllProducts(filtered);
            }
        } catch (error) {
            console.error('Error fetching product:', error);
        }
    };

    useEffect(() => {
        fetchProduct()
    }, [searchItem])

    const homePage = () => {
        navigate('/');
    }

    const dashboard = () => {
        navigate('/Dashboard');
    }


    const imageuploadpage = () => {
        navigate('/imageupload');
    }

    const offerUpdatepage = () => {
        navigate('/offerupdate');
    }

    const categoryaddpage = () => {
        navigate('/subcategoryadd');
    }

    const handleAllColorsUpdate = () => {
        navigate('/updateColors');
    }

    const handleAllProductsUpdate = () => {
        navigate('/updateProducts');
    }

    const handleSearch = (e) => {
        setSearchItem(e.target.value)
    }


    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-dmSans">
            <AdminHeader />

            <div className="flex-grow py-6 lg:py-12 lg:px-12 px-4">
                <div className="max-w-7xl mx-auto">
                    {/* Header Section */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
                        <div className="flex flex-col">
                            <h1 className="text-2xl lg:text-3xl font-black text-gray-900 font-montserrat uppercase tracking-tight">Product Control</h1>
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-[0.2em] mt-1">Manage Size Property for {allProducts.length} Items</p>
                        </div>

                        <div className="flex items-center gap-3 bg-white p-2 rounded-2xl shadow-sm border border-gray-100 w-full md:w-auto">
                            <div className="relative flex-grow md:w-64">
                                <input
                                    type="text"
                                    className="w-full bg-gray-50 border-none rounded-xl px-4 py-2.5 pl-10 text-sm font-bold focus:ring-2 focus:ring-black/5 transition-all placeholder:text-gray-300 uppercase tracking-widest"
                                    value={searchItem}
                                    placeholder="Search products..."
                                    onChange={handleSearch}
                                />
                                <svg className="absolute left-3 top-3 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            </div>
                            <button
                                onClick={() => setSearchItem('')}
                                className="p-2.5 bg-gray-100 hover:bg-black hover:text-white text-gray-400 rounded-xl transition-all active:scale-95"
                                title="Reset Search"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                            </button>
                        </div>
                    </div>

                    {/* Desktop Table View */}
                    <div className="hidden lg:block bg-white shadow-2xl rounded-[2rem] border border-gray-100 overflow-hidden">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="bg-black text-white">
                                    <th className="px-8 py-5 text-xs font-black uppercase tracking-[0.2em] w-24">SI.No</th>
                                    <th className="px-8 py-5 text-xs font-black uppercase tracking-[0.2em]">Item Name</th>
                                    <th className="px-8 py-5 text-xs font-black uppercase tracking-[0.2em] text-center w-48">Size Support</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allProducts.map((pro, index) => {
                                    const isOn = pro.noSize === null;
                                    const handleSizeUpdate = async (slno) => {
                                        try {
                                            const newNoSize = isOn ? 1 : null;
                                            const response = await axios.post(`${apiBaseUrl}/updateIsSize/BLACKBATON_2526`, { slno, noSize: newNoSize });
                                            if (response.data.success) {
                                                setAllProducts(prev => prev.map(item => item.slno === slno ? { ...item, noSize: newNoSize } : item));
                                            }
                                        } catch (error) { console.error("Error updating size:", error); }
                                    };

                                    return (
                                        <tr key={pro.slno} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0`}>
                                            <td className="px-8 py-6 text-sm font-black text-gray-400">{index + 1}</td>
                                            <td className="px-8 py-6 text-sm font-900 text-gray-900 font-montserrat uppercase">{pro.itemname}</td>
                                            <td className="px-8 py-6 text-center">
                                                <button
                                                    onClick={() => handleSizeUpdate(pro.slno)}
                                                    className={`px-6 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all shadow-sm active:scale-95
                                                        ${isOn ? 'bg-green-100 text-green-600 hover:bg-green-600 hover:text-white' : 'bg-red-100 text-red-600 hover:bg-red-600 hover:text-white'}`}
                                                >
                                                    {isOn ? 'Has Size' : 'No Size'}
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Mobile Card View */}
                    <div className="lg:hidden space-y-4">
                        {allProducts.length === 0 ? (
                            <div className="p-12 text-center bg-white rounded-3xl border border-gray-100">
                                <span className="text-sm font-bold text-gray-300 uppercase tracking-widest">No products found</span>
                            </div>
                        ) : (
                            allProducts.map((pro, index) => {
                                const isOn = pro.noSize === null;
                                const handleSizeUpdate = async (slno) => {
                                    try {
                                        const newNoSize = isOn ? 1 : null;
                                        const response = await axios.post(`${apiBaseUrl}/updateIsSize/BLACKBATON_2526`, { slno, noSize: newNoSize });
                                        if (response.data.success) {
                                            setAllProducts(prev => prev.map(item => item.slno === slno ? { ...item, noSize: newNoSize } : item));
                                        }
                                    } catch (error) { console.error("Error updating size:", error); }
                                };

                                return (
                                    <div key={pro.slno} className="bg-white p-5 rounded-[2rem] border border-gray-100 shadow-sm flex items-center justify-between">
                                        <div className="flex flex-col pr-4">
                                            <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest mb-1">Item #{pro.slno}</span>
                                            <h3 className="text-sm font-900 text-gray-900 font-montserrat uppercase leading-tight">{pro.itemname}</h3>
                                        </div>
                                        <button
                                            onClick={() => handleSizeUpdate(pro.slno)}
                                            className={`min-w-[90px] h-10 rounded-2xl text-[9px] font-black uppercase tracking-widest shadow-lg active:scale-95 transition-all
                                                ${isOn ? 'bg-black text-white shadow-black/20' : 'bg-gray-100 text-gray-400'}`}
                                        >
                                            {isOn ? 'Enabled' : 'Disabled'}
                                        </button>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateProducts;